export default {
  dialog_aria: 'Busca global do painel',
  results_aria: 'Resultados da busca',
  areas: 'Áreas',
  items: 'Itens',
  loading: 'Buscando…',
  empty: 'Nada encontrado para "{q}".',
  error: 'Não foi possível buscar agora.',
  retry: 'Tentar novamente',
  type_tag: 'Localizador',
  type_phone: 'Rastreador',
  type_geofence: 'Cerca',
  type_member: 'Usuário',
  type_order: 'Pedido',
  shape_circle: 'Circular',
  shape_polygon: 'Polígono',
  recent: 'Recentes',
  clear: 'Limpar',
  hint_navigate: 'navegar',
  hint_open: 'abrir',
  hint_close: 'fechar',
  hint_shortcut: 'abre a busca',
}
